/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询当前登录用户所有的剧院会员以及在该剧院内的可用积分
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<member.TheaterMemberIntegralDTO>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/theaters/integral`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
